import { usePayments } from './use-payments';

export function useDashboardStats() {
  const refetchInterval = 10_000;

  const allQuery = usePayments({ size: 1, refetchInterval });
  const pendingQuery = usePayments({ status: 'PENDING', size: 1, refetchInterval });
  const paidQuery = usePayments({ status: 'PAID', size: 1, refetchInterval });
  const completedQuery = usePayments({ status: 'COMPLETED', size: 1, refetchInterval });
  const failedQuery = usePayments({ status: 'FAILED', size: 1, refetchInterval });
  const cancelledQuery = usePayments({ status: 'CANCELLED', size: 1, refetchInterval });
  const recentQuery = usePayments({ size: 5, refetchInterval });

  const queries = [allQuery, pendingQuery, paidQuery, completedQuery, failedQuery, cancelledQuery, recentQuery];
  const isLoading = queries.some((q) => q.isLoading);
  const error = queries.find((q) => q.error)?.error;

  return {
    stats: {
      total: allQuery.data?.totalElements ?? 0,
      pending: pendingQuery.data?.totalElements ?? 0,
      paid: (paidQuery.data?.totalElements ?? 0) + (completedQuery.data?.totalElements ?? 0),
      failed: (failedQuery.data?.totalElements ?? 0) + (cancelledQuery.data?.totalElements ?? 0),
    },
    recentPayments: recentQuery.data?.content ?? [],
    isLoading,
    error: error instanceof Error ? error.message : error ? String(error) : null,
  };
}
